import { Link } from "@tanstack/react-router";
import { BOOKING_URL, GROUP_CALL_URL } from "@/content/booking";

type Props = {
  children: React.ReactNode;
  className?: string;
  /** Atrybuty CTA dla pomiaru cta_click (helper cta()). */
  cta?: Record<string, string>;
};

/**
 * Przycisk rezerwacji konsultacji indywidualnej. Kieruje do zewnętrznego systemu rezerwacji,
 * gdy BOOKING_URL jest ustawiony, w przeciwnym razie do wewnętrznego ekranu
 * rezerwacji i płatności (/rezerwacja).
 */
export function BookingCta({ children, className = "btn-base btn-primary", cta }: Props) {
  const classes = `${className} inline-flex min-h-11 items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral`;

  if (BOOKING_URL) {
    return (
      <a href={BOOKING_URL} {...cta} className={classes} rel="noopener">
        {children}
      </a>
    );
  }

  return (
    <Link to="/rezerwacja" {...cta} className={classes}>
      {children}
    </Link>
  );
}


/**
 * Przycisk rezerwacji 30-minutowej rozmowy wstępnej do mastermindu.
 * Bez skonfigurowanego GROUP_CALL_URL kieruje na stronę kontaktu.
 */
export function GroupCallCta({ children, className = "btn-base btn-primary", cta }: Props) {
  const classes = `${className} inline-flex min-h-11 items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral`;

  if (GROUP_CALL_URL) {
    return (
      <a href={GROUP_CALL_URL} {...cta} className={classes} rel="noopener">
        {children}
      </a>
    );
  }

  return (
    <Link to="/kontakt" {...cta} className={classes}>
      {children}
    </Link>
  );
}
